var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room",
      attrs: {
        "data-grm-comp": "Room",
        "data-roomid": _vm.room.roomId,
        "data-groupid": _vm.room.groupId,
        "data-roomType": _vm.room.roomType,
        "data-open-extend-menu": _vm.isOpenExtendMenu,
      },
    },
    [
      _vm.readyToEnter && !_vm.isLeaved
        ? [
            _c("RoomMenu", {
              attrs: {
                isOpenExtendMenu: _vm.isOpenExtendMenu,
                isOpenRoomStickerModal: _vm.isOpenRoomStickerModal,
              },
              on: {
                "update:isOpenRoomStickerModal": function ($event) {
                  _vm.isOpenRoomStickerModal = $event
                },
                "update:is-open-room-sticker-modal": function ($event) {
                  _vm.isOpenRoomStickerModal = $event
                },
              },
            }),
            _c(
              "div",
              { staticClass: "room-container" },
              [
                _c("RoomControls", {
                  attrs: { isOpenExtendMenu: _vm.isOpenExtendMenu },
                  on: {
                    "update:isOpenExtendMenu": function ($event) {
                      _vm.isOpenExtendMenu = $event
                    },
                    "update:is-open-extend-menu": function ($event) {
                      _vm.isOpenExtendMenu = $event
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      "min-height": "0",
                      display: "flex",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "room-main" },
                      [
                        _c("RoomCallAudio"),
                        _c(
                          "transition-group",
                          { attrs: { name: "fade" } },
                          [
                            !_vm.isRoomMode("media")
                              ? _c(_vm.roomMainComponent, {
                                  key: "room-main",
                                  tag: "component",
                                  staticClass: "room-main-component",
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        !!_vm.roomMode
                          ? _c(
                              "transition",
                              { attrs: { name: "fade" } },
                              [
                                _c("RoomMediaShare", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isRoomMode("media"),
                                      expression: "isRoomMode('media')",
                                    },
                                  ],
                                  ref: "mediaShare",
                                  staticClass: "room-main-component",
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.$store.state.call.showConnectionStats === true
                          ? _c("RoomCallConnectionState", {
                              staticStyle: {
                                position: "absolute",
                                "z-index": "10",
                                top: "0px",
                                left: "0",
                                "pointer-events": "none",
                              },
                            })
                          : _vm._e(),
                        _vm.showRoomConnectionStateLoading
                          ? _c("Loading", {
                              attrs: {
                                msg: _vm.$t(
                                  "room.connectionState.msg." +
                                    _vm.connectionState
                                ),
                              },
                            })
                          : _vm._e(),
                        _c("GrmSnackbarList", {
                          attrs: { isOpenExtendMenu: _vm.isOpenExtendMenu },
                        }),
                      ],
                      1
                    ),
                    _c("RoomExtendMenu", {
                      ref: "roomExtendMenu",
                      class: { isOpen: _vm.isOpenExtendMenu },
                      on: {
                        closeExtendMenu: _vm.closeExtendMenu,
                        toggleNewWindowMenu: _vm.toggleNewWindowMenu,
                      },
                      nativeOn: {
                        transitionend: function ($event) {
                          return _vm.onTransitionend.apply(null, arguments)
                        },
                      },
                    }),
                    _c(
                      "RoomWindowOpen",
                      {
                        ref: "newWindowMenu",
                        attrs: {
                          title: `[Gooroomee-PIP] ${_vm.$t(
                            "setting.chat.title"
                          )}`,
                          width: 320,
                          minWidth: 320,
                          height: 800,
                          minHeight: 800,
                        },
                      },
                      [
                        _c("RoomExtendMenu", {
                          attrs: {
                            chatHistoryProp: _vm.chatHistory(),
                            newWindow: "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("RoomNotification", {
                      attrs: { isOpenExtendMenu: _vm.isOpenExtendMenu },
                      on: {
                        openExtendMenu: function ($event) {
                          _vm.isOpenExtendMenu = true
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "transition-group",
              { attrs: { name: "fade" } },
              [
                _vm.isOpenRoomStickerModal
                  ? _c("RoomStickerModal", {
                      key: "room-sticker-modal",
                      staticClass: "slide-right",
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : [
            _vm.isShowSetDevice
              ? _c("RoomDeviceSetting", {
                  ref: "waitingRoom",
                  attrs: {
                    roomInfo: _vm.room,
                    deviceSettings: _vm.deviceSettings,
                    isDevicetest: "",
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }